/* *@description: 模糊查询组件 */
<template>
  <div class="base-select">
    <el-select
      v-model="propObj[nameDto]"
      :placeholder="$t(placeholder)"
      :remote-method="remoteMethod"
      filterable
      remote
      reserve-keyword
      clearable
      :allow-create="allowCreate"
      @change="selectInfo(propObj[nameDto])"
      :disabled="disabled"
    >
      <el-option
        v-for="item in selectData"
        :key="item.id"
        :label="item.label"
        :value="item.label"
      >
        <span style="float: left"
          >{{ item.label }} &nbsp;&nbsp;&nbsp;&nbsp;</span
        >
        <span v-if="codeDto" style="float: right"
          >({{
            isDict ? dictFilter(item[codeDto], DICT[dictData]) : item[codeDto]
          }})</span
        >
      </el-option>
    </el-select>
  </div>
</template>
<script setup name="BaseSelect">
import request from '@/utils/request';
import { $t } from '@/plugins/i18n';
import { reactive, toRefs, defineEmits, defineProps } from 'vue';
import { dictFilter } from '@/utils/commonFun';
import { DynamicDictModel } from '@/utils/dictModules/model';
const dynamicDictModel = new DynamicDictModel();
const DICT = dynamicDictModel.init($t);
const emits = defineEmits(['select']);
const isArray = data => Array.isArray(data);
const props = defineProps({
  propObj: {
    // 需要赋值的对象
    type: Object,
    default: () => {
      return {};
    }
  },
  allowCreate: {
    // 是否允许自定义条目
    type: Boolean,
    default: false
  },
  nameDto: {
    // 入参字段名称
    type: [String, Array],
    default: 'name'
  },
  nameVos: {
    // 接口出参使用的字段  出参如果有优先级则改字段传入的应该为数据类型如：[A, B]，此时取值优先A， A为空则取B
    type: [String, Array],
    default: 'name'
  },

  dicUrl: {
    // 接口地址
    type: String,
    default: ''
  },
  query: {
    // 查询入参
    type: Object,
    default: () => {
      return { current: 1, size: 100 };
    }
  },
  throwWrong: {
    // 是否抛错， 默认不抛错
    type: Boolean,
    default: false
  },
  disabled: {
    // 是否禁用
    type: Boolean,
    default: false
  },
  keyword: {
    // 搜索入参字段key
    type: String,
    default: 'keyword'
  },
  keywordValueType: {
    // 搜索入参字段value类型
    type: String,
    default: 'string'
  },
  placeholder: {
    // 搜索提示语
    type: String,
    default: '请输入'
  },
  method: {
    // 请求类型 默认get
    type: String,
    default: 'get'
  },
  isQueryKeyRequired: {
    // 远程搜索 keyword 是否必填
    type: Boolean,
    default: false
  },
  codeDto: {
    // 下拉表展示 code
    type: String,
    default: ''
  },
  isDict: {
    // code 位置是否展示数据字典
    type: Boolean,
    default: false
  },
  dictData: {
    // 数据字典
    type: Array,
    default: () => []
  }
});
const data = reactive({
  selectData: [],
  loading: false
});
const { selectData, loading } = toRefs(data);
const {
  propObj,
  allowCreate,
  nameVos,
  dicUrl,
  query,
  throwWrong,
  disabled,
  keyword,
  keywordValueType,
  placeholder,
  method,
  isQueryKeyRequired
} = toRefs(props);

async function remoteMethod(name) {
  console.log('remoteMethod', method.value, name);
  if (isQueryKeyRequired.value && !name) {
    return;
  }
  try {
    console.log(name, query.value);
    const params = {
      ...query.value,
      [keyword.value]: keywordValueType.value === 'array' ? [name] : name
    };
    let response = {};
    if (method.value === 'get') {
      response = await request({
        url: dicUrl.value,
        method: 'get',
        params
      });
    } else {
      response = await request({
        url: dicUrl.value,
        method: 'post',
        data: params
      });
    }
    const { code, data, msg } = response;
    loading.value = false;
    if (code === 1) {
      const rescords =
        data && isArray(data)
          ? data
          : data.records && isArray(data.records)
          ? data.records
          : [];
      const nameVosIsArray =
        Object.prototype.toString.call(nameVos.value) === '[object Array]';
      console.log(nameVosIsArray, nameVos);
      rescords.forEach(item => {
        const label = nameVosIsArray
          ? item[nameVos.value[0]]
          : item[nameVos.value];
        const value = nameVosIsArray
          ? item[nameVos.value[1]]
          : item[nameVos.value];
        item.label = label;
        item.value = value;
      });
      selectData.value = rescords;
    } else {
      if (throwWrong.value) this.$message.error($t(msg));
    }
  } catch (error) {
    loading.value = false;
  }
}
function selectInfo(v) {
  console.log('selectInfo', v);
  if (v) {
    const obj = selectData.value.find(item => item.label === v);
    emits('select', obj);
  } else {
    emits('select', undefined);
  }
}
</script>

<style lang="scss" scoped>
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  right: 5px !important;
}
</style>
